import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material'
import { styled } from '@mui/system'
import { alpha } from '@mui/material/styles'
import { NavLink } from 'react-router'
import colors, { STATE_LAYER_OPACITY, SHAPE_SCALE } from 'common/colors'

export default function CommonSidebarLink(props) {
  const { label, icon, children, testId, ...linkProps } = props

  return (
    <StyledListItem
      disablePadding
      component={NavLink}
      data-testid={testId}
      {...linkProps}
    >
      {label && (
        <ListItemButton>
          {icon && (
            <ListItemIcon sx={{ minWidth: '24px', marginRight: '12px' }}>
              {icon}
            </ListItemIcon>
          )}
          <ListItemText primary={label} sx={{ fontWeight: 'bolder' }} />
        </ListItemButton>
      )}
      {children}
    </StyledListItem>
  )
}

const StyledListItem = styled(ListItem)({
  // M3's nav drawer marks the selected item with a pill-shaped indicator
  // inset from the row edges, behind just the icon+label — not a flat wash
  // across the full row width (the previous, M2-style treatment). That
  // inset margin eats into the fixed-width (250px) drawer's available
  // label space on top of the button's own default 16px horizontal
  // padding. Just offsetting the margin 1:1 with equal padding restores
  // the pre-M3 pixel budget exactly, but that budget turns out to have
  // been razor-thin for longer labels to begin with (e.g. "Available
  // Organizations" in the admin sidebar) — the M3 migration's own font
  // swap (Open Sans, capped at a self-hosted 700 with no 500, -> Roboto,
  // which self-hosts a true 500) and body1's new, wider M3 letter-spacing
  // land right on that edge, so an exact restoration still wraps. Trim
  // the inset to 4px and the padding further to compensate, netting real
  // extra width instead of just breaking even.
  '& .MuiListItemButton-root': {
    margin: '2px 4px',
    paddingLeft: '8px',
    paddingRight: '8px',
    borderRadius: SHAPE_SCALE.largeIncreased,
  },
  '&.active .MuiListItemButton-root': {
    backgroundColor: alpha(colors.brand, STATE_LAYER_OPACITY.selected),
  },
  '&.active': {
    '& .MuiTypography-root': {
      color: '#000',
      fontWeight: 500,
    },
    '& .MuiListItemIcon-root svg path': {
      fill: colors.brand,
    },
  },
  '& .MuiTypography-root': {
    color: '#000',
    fontWeight: 500,
  },
})
